import { createSelector } from 'reselect';
import Constants from './constants';

const STATE_KEY_NAME = Constants.MODULE_NAME;

const stateSelector = (state) => state[STATE_KEY_NAME];

const profileDetailsSelector = createSelector(stateSelector, (state) => state.profileDetails);

const profileEmailSelector = createSelector(profileDetailsSelector, (state) => state?.email);

const profileDetailsUpdateStatusSelector = createSelector(stateSelector, (state) => state.profileDetailsUpdateStatus);
const passwordUpdateStatusSelector = createSelector(stateSelector, (state) => state.passwordUpdateStatus);
const passwordLoadingSelector = createSelector(stateSelector, (state) => state.isLoadingPassword);
const profileLoadingSelector = createSelector(stateSelector, (state) => state.isLoadingProfileUpdate);

const profileIsInvitedSelector = createSelector(stateSelector, (state) => state.invitation.isInvited);

const profileInvitedBySelector = createSelector(stateSelector, (state) => state.invitation.invitedBy);

const profileInviteIdSelector = createSelector(stateSelector, (state) => state.invitation.inviteId);

const profileInvitedByOrgNameSelector = createSelector(stateSelector, (state) => state.invitation.invitedByOrgName);

export const ProfileSelectors = {
  profileEmailSelector,
  profileDetailsSelector,
  profileDetailsUpdateStatusSelector,
  passwordUpdateStatusSelector,
  passwordLoadingSelector,
  profileLoadingSelector,

  profileIsInvitedSelector,
  profileInviteIdSelector,
  profileInvitedBySelector,
  profileInvitedByOrgNameSelector,
};
